import { Button, Icon, Layout, Text } from '@loadsmart/miranda-react'

import { TrackingProvider } from '../../domain/Tracking'
import { ProvidersBadge } from './ProvidersBadge'
import { ProviderCard } from './styles'

type AssignDriverCardContentProps = {
  readonly onClick: () => void
}

export function AssignDriverCardContent({ onClick }: AssignDriverCardContentProps) {
  return (
    <ProviderCard onClick={onClick} aria-labelledby="assign-driver-label">
      <Layout.Stack gap="spacing-2">
        <Layout.Group align="center" justify="space-between">
          <Layout.Group gap="spacing-2">
            <ProvidersBadge providers={[TrackingProvider.Loadsmart]} />
            <ProvidersBadge providers={[TrackingProvider.P44]} />
            <ProvidersBadge providers={[TrackingProvider.TT]} />
          </Layout.Group>
          <Button aria-label="Assign driver" variant="icon-secondary" size="small">
            <Icon name="add-circle" size="20px" color="color-text-placeholder" />
          </Button>
        </Layout.Group>
        <Text id="assign-driver-label" variant="body-md-bold" color="color-text-secondary">
          Assign a driver to track using the mobile app
        </Text>
        <Text variant="body-sm" color="color-text-placeholder">
          An SMS will be sent to the driver connect using the mobile app.
        </Text>
      </Layout.Stack>
    </ProviderCard>
  )
}
